<template>
  <div class="dialog-root">
    <div class="container">
      <el-form :model="formData" label-width="80px">
        <el-row>
          <el-col>
            <el-form-item label="标题">
              <el-input
                v-model="formData.title"
                placeholder="请输入 标题"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="formData.description"
                placeholder="请输入 备注"
                maxlength="50"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">保存</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { collectionApi } from '@/api/call-system/call-manage/recording-manage';

export default {
  props: ['rowData'],
  data() {
    return {
      formData: {}, // 表单数据
    };
  },

  created() {
    this.formData.id = this.rowData.id;
    this.formData.favoriteFlag = 1;
  },
  methods: {
    /* 保存 */
    doSave() {
      collectionApi(this.formData, {
        showLoading: { text: '处理中...' },
      }).then(() => {
        this.$message.success('操作成功!');
        this.$emit('update');
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
